import Hammer from 'hammerjs'

$.fn.Slideshow_Slide = function() {
  let self = this

  self.getNaturalWidth = function() {
    return parseInt(self.find('img').attr('width'), 10)
  }

  self.getNaturalHeight = function() {
    return parseInt(self.find('img').attr('height'), 10)
  }

  return function() {
    return self
  }()
}

$.fn.Slideshow = function(mobileChecker) {
  let self = this
  self.slides = []
  self.wrapper = self.find('.slideshow__wrapper')
  self.ratio = undefined

  /* State */
  self.status = {
    animating: false,
    timeout: undefined,
    timeout_1: undefined,
    timeout_2: undefined,
  }
  self.previousSlide = undefined
  self.currentSlide = undefined
  self.nextSlide = undefined

  self.calculateHeight = function() {
    self.wrapper.css({
      height: Math.ceil(self.slides[0].outerWidth(false) / self.ratio) + 'px',
    })
  }

  self.switchSlide = function(e) {
    /* State of switch */
    if (self.status.animating) return false
    clearTimeout(self.status.timeout)
    self.status.animating = true

    /* Transition between slides */
    self.previousSlide = self.currentSlide
    if (e != undefined && e.type == 'swiperight') {
      self.nextSlide = self.previousSlide.prevAll().not(self.previousSlide).slice(0, mobileChecker.isMobile ? 1 : 2)
      if (!self.nextSlide.length) {
        self.nextSlide = self.find('.slideshow__slide').slice(mobileChecker.isMobile ? -1 : -2)
      }
      self.nextSlide.addClass('slideshow__slide--reverse')
    } else {
      self.nextSlide = self.previousSlide.nextAll().not(self.previousSlide).slice(0, mobileChecker.isMobile ? 1 : 2)
      if (!self.nextSlide.length) {
        self.nextSlide = self.find('.slideshow__slide').slice(0, mobileChecker.isMobile ? 1 : 2)
      }
    }
    self.nextSlide.addClass('slideshow__slide--next')

    /* Sequencing animating */
    self.status.timeout_1 = setTimeout(function() {
      self.previousSlide.addClass('slideshow__slide--previous')
      self.nextSlide.removeClass('slideshow__slide--next').addClass('slideshow__slide--active')
      self.currentSlide = self.nextSlide
    }, 100)
    self.status.timeout_2 = setTimeout(function() {
      self.currentSlide.removeClass('slideshow__slide--reverse')
      self.previousSlide.removeClass('slideshow__slide--next slideshow__slide--active slideshow__slide--previous slideshow__slide--reverse')
      self.nextSlide = undefined
      self.previousSlide = undefined
      self.status.animating = false
    }, 560)
  }

  self.toggleResponsive = function() {
    self.kill()
    self.previousSlide = undefined
    self.nextSlide = undefined
    self.find('.slideshow__slide').removeClass('slideshow__slide--next slideshow__slide--active slideshow__slide--previous slideshow__slide--reverse')
    self.currentSlide = self.find('.slideshow__slide:lt(' + (mobileChecker.isMobile ? 1 : 2) + ')')
    self.currentSlide.addClass('slideshow__slide--active')
  }

  self.kill = function() {
    clearTimeout(self.status.timeout)
    clearTimeout(self.status.timeout_1)
    clearTimeout(self.status.timeout_2)
    self.status.animating = false
  }

  return function() {
    /* Gather slides */
    self.find('.slideshow__slide').each(function() {
      let slide = $(this).Slideshow_Slide()
      self.slides.push(slide)
    })

    /* Initialize behavior */
    if (self.slides.length) {
      /* Get initial values */
      self.ratio = self.slides[0].getNaturalWidth() / self.slides[0].getNaturalHeight()

      /* Calculate height dynamically */
      $(window).on('load orientationchange resize', self.calculateHeight)
      self.calculateHeight()

      /* Switch slide on click, delay and horizontal swipe */
      const slideshowHammer = new Hammer(self.get(0))
      slideshowHammer.get('swipe').set({ direction: Hammer.DIRECTION_ALL })
      slideshowHammer.on('swipeleft swiperight', self.switchSlide)
      self.find('.slideshow__next').on('click', self.switchSlide)

      /* Mobile toggle */
      mobileChecker.addCallbacks(self.toggleResponsive, self.toggleResponsive)
    }
    return self
  }()
}

let instances = []

export default {
  init(mobileChecker) {
    $('.slideshow').each(function() {
      let instance = $(this).Slideshow(mobileChecker)
      instances.push(instance)
    })
  },

  kill() {
    instances.forEach(function(instance) {
      instance.kill()
    })
  },
}
